"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = exports.allTimeRanges = void 0;

var _preact = require("preact");

var _Tabs = _interopRequireDefault(require("@insided/deprecated-preact-components/Tabs"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _widgetContainer = _interopRequireWildcard(require("@insided/deprecated-preact-components/widget-container"));

var _LeaderboardUserList = _interopRequireDefault(require("./LeaderboardUserList"));

var _zod = require("zod");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var allTimeRanges = ['thisWeek', 'allTime'];
exports.allTimeRanges = allTimeRanges;
var widgetName = 'leaderboard_points';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-leaderboard_points';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  maxResults: _zod.z.number(),
  timeRange: _zod.z.array(_zod.z.enum(['thisWeek', 'allTime'])),
  excludeUserRole: _zod.z.array(_zod.z.string()).optional(),
  emptyMessage: _zod.z.string(),
  isPreviewEmptyMessage: _zod.z.boolean(),
  usersList: _zod.z.array(_zod.z.object({
    id: _zod.z.number(),
    name: _zod.z.string(),
    avatar: _zod.z.string(),
    points: _zod.z.number(),
    leaderboardPosition: _zod.z.number(),
    rank: _zod.z.string().optional()
  })),
  title: _zod.z.string(),
  showLink: _zod.z.boolean(),
  linkText: _zod.z.string().optional(),
  showLoggedInUserSection: _zod.z.boolean()
}).merge(_widgetContainer.widgetContainerConfig);

exports.config = config;

var PointsLeaderboard = function PointsLeaderboard(_ref) {
  var timeRange = _ref.timeRange,
      maxResults = _ref.maxResults,
      usersList = _ref.usersList,
      excludeUserRole = _ref.excludeUserRole,
      emptyMessage = _ref.emptyMessage,
      isPreviewEmptyMessage = _ref.isPreviewEmptyMessage,
      showLink = _ref.showLink,
      linkText = _ref.linkText,
      showLoggedInUserSection = _ref.showLoggedInUserSection,
      config = _ref.config;
  var classNames = 'widget--leaderboard_points qa-widget-leaderboard_points';
  var tabs = timeRange || allTimeRanges;
  var tabTitles = tabs.map(function (tab) {
    return (0, _preact.h)(_phrase.default, {
      key: tab,
      p: "leaderboard.points.".concat(tab)
    });
  });
  return (0, _preact.h)(_widgetContainer.default, {
    widgetName: widgetName,
    config: config,
    className: classNames
  }, (0, _preact.h)("div", {
    className: "leaderboard-container"
  }, (0, _preact.h)(_Tabs.default, {
    titles: tabTitles
  }, tabs.map(function (tab) {
    return (0, _preact.h)(_LeaderboardUserList.default, {
      key: tab,
      tabTitle: tab,
      maxResults: maxResults,
      usersList: usersList,
      excludeUserRole: excludeUserRole !== null && excludeUserRole !== void 0 ? excludeUserRole : [],
      emptyMessage: emptyMessage,
      isPreviewEmptyMessage: isPreviewEmptyMessage,
      showLink: showLink,
      linkText: linkText,
      showLoggedInUserSection: showLoggedInUserSection
    });
  }))));
};

var _default = PointsLeaderboard;
exports.default = _default;